import styled from 'styled-components';

export const StyledTimeActions = styled.div`
  display: flex;
  align-items: center;
`;
